import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=a8d645a8&scoped=true&"
import script from "./MenuBar.vue?vue&type=script&lang=ts&"
export * from "./MenuBar.vue?vue&type=script&lang=ts&"
import style0 from "./MenuBar.vue?vue&type=style&index=0&id=a8d645a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d645a8",
  null
  
)

export default component.exports